import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../providers";
import { PaymentStrings } from "../../../../business/core";
import { PaymentOrdersPageControllerImpl } from "../../../../business/impl";

interface IStrategyButtonBankSlipSend {
    id: string;
    status: number;
}

export const StrategyButtonBankSlipSend: React.FC<IStrategyButtonBankSlipSend> = ({ id, status }) => {
    const { setCallbackLogin, handleLogout } = useAuth();
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState<boolean>(false);
    const strings = PaymentStrings['PTBR'].payment_order.strategy_buttons;

    const handlerSendBankSlip = async () => {
        setLoading(true);

        const formData = new FormData();
        formData.append("payment_order", id);

        const controller = new PaymentOrdersPageControllerImpl();
        try {
            const response = await controller.sendBankInvoice(formData);
            localStorage.setItem('global-toast', JSON.stringify({ type: 'success', message: response.response.toString() }));
            window.location.reload();
        } catch (error) {
            switch (error) {
                case "401":
                    setCallbackLogin(
                        {
                            goBack: true,
                            origin: '/adm/dashboard',
                        }
                    );
                    handleLogout();
                    navigate('/auth');
                    break;
                case "403":
                    navigate('/subscription');
                    break
                default:
                    localStorage.setItem('global-toast', JSON.stringify({ type: 'danger', message: 'Erro na requisição' }));
                    window.location.reload();
                    break;
            }
        }
    }
    const variantButton = () => {
        let variant = '';
        variant = status === 0 ? `${variant}danger` : `${variant}secondary`;
        return variant;
    }

    return (
        <>
            <Button
                size="sm"
                onClick={() => handlerSendBankSlip()}
                variant={variantButton()}
                disabled={isLoading}>
                {isLoading
                    ? <Spinner size="sm" />
                    : <>
                        {strings.send_bank_slip_button_label}
                    </>
                }
            </Button>
            <Modal
                show={isLoading}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body className="text-center">
                    <Spinner />
                </Modal.Body>
            </Modal>
        </>
    )
}